// Lot-Pool Adapter — Single Source of Truth ist fifo.js / buildFifoPool().
// Diese Datei mappt den fifo-Pool auf das historische AssetLot-Schema, das
// portfolioCalc.js, reconciliationEngine.js, taxLots-Konsumenten und Tests
// erwarten. Keine eigene FIFO-Logik mehr — keine zweite Pool-Wahrheit.

import { buildFifoPool } from './fifo';

/**
 * @param {Array} txs           Rohe Transaktionen
 * @param {Array} _transferPairs Ignoriert (fifo.js berechnet pairs intern). Bleibt
 *                              in der Signatur fuer Backward-Compat aller bisherigen
 *                              Aufrufer.
 * @returns {Object} { [coin]: AssetLot[] }
 *   AssetLot: { lotId, asset, originalBuyDate, originalBuyPrice, originalAmount,
 *               remainingAmount, sourceTransactionId, location, costBasisUnknown,
 *               overConsumption }
 */
// eslint-disable-next-line no-unused-vars
export function buildLots(txs, _transferPairs, opts = {}) {
  const pool = opts.prebuiltFifo?.pool ?? buildFifoPool(txs).pool;
  return mapPoolToLots(pool);
}

/**
 * Mappt einen bereits berechneten fifo-Pool auf das AssetLot-Schema, ohne
 * buildFifoPool erneut aufzurufen. Wird genutzt, wenn Aufrufer den Pool
 * vorab gebaut und an mehrere Konsumenten weiterreichen wollen
 * (siehe Dashboard.js: ein FIFO-Lauf -> calcPortfolio + buildReport).
 */
export function mapPoolToLots(pool) {
  const out = {};
  for (const [coin, lots] of Object.entries(pool || {})) {
    out[coin] = lots.map(l => ({
      lotId:               l.lotId,
      asset:               coin,
      originalBuyDate:     l.datum,
      originalBuyPrice:    l.stueck,
      originalAmount:      l.originalAmount,
      remainingAmount:     l.rest,
      sourceTransactionId: l.sourceTransactionId,
      location:            l.location,
      costBasisUnknown:    !!l.costBasisUnknown,
      overConsumption:     !!l.overConsumption,
    }));
  }
  return out;
}
